import { render, staticRenderFns } from "./indexlocal.vue?vue&type=template&id=23a69f1a"
import script from "./indexlocal.vue?vue&type=script&lang=js"
export * from "./indexlocal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports